export function led(_ctx) {
    return {
        styles: {
            main: {
                bg_color:     '#ffffff',
                bg_opa:       255,
                border_width: 2,
                border_color: '#ffffff',
                radius:       999,
            },
        },
    };
}
